import { render, staticRenderFns } from "./serviceRevenueData.vue?vue&type=template&id=45365e8c&scoped=true&"
import script from "./serviceRevenueData.vue?vue&type=script&lang=js&"
export * from "./serviceRevenueData.vue?vue&type=script&lang=js&"
import style0 from "./serviceRevenueData.vue?vue&type=style&index=0&id=45365e8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45365e8c",
  null
  
)

export default component.exports